<template>
    <div class="card-wrap">
        <!-- 海报保存 -->
        <div class="container2" v-if="posterShow"  ref="invitationImgRef">
            <img src="@/assets/images/user/talk/background.png" alt="">
            <div style="z-index:999;position:relative;">
                <div class="title">
                    敬请扫码
                </div>
                <div class="qrcode" id="qrcode" ref="qrcodeBox"></div>
                <div class="userinfo">
                    <div class="user-name-title">邀约人:</div>
                    <div class="user-name">{{ReportUserInfoData.sign_name}}</div>
                    <div>联系方式:</div>
                    <div>{{ReportUserInfoData.sign_phone}}</div>
                </div>
            </div>
        </div>
        <!-- 主要内容 -->
        <div class="card-title flc">
            <div class="color-block"></div>
            <div class="card-title-text">预约回顾</div>
        </div>
        <div id="chart-bar"></div>
        <div class="card-title flc">
            <div class="color-block"></div>
            <div class="card-title-text">预约记录</div>
        </div>
        <div class="record-input">
            <input placeholder="搜索预约记录" type="text" v-model="searchText" @change="search">
            <img src="@/assets/images/user/talk/search_icon.png" alt="" @click="search">
        </div>
        <van-list :loading="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" :offset="100" @load="loadOver">
            <div class="record-list">
                <div class="record-item" v-for="item in ReportListData" :key="item.id">
                    <!-- <div class="signBtn" @click="signClick(item.id)"> -->
                    <!-- <div class="signBtn" :style="{'background':(item.mark_date + '23:59:59')>newDate?'linear-gradient(90deg, #46B46B 0%, #318544 100%);':'grey;'}" v-if="item.state == 3" @click="signClick(item.id)" > -->
                    <div class="signBtn" v-if="item.state == 3&&(item.mark_end.substring(0,10) + '23:59:59') >newDate" @click="signClick(item.sub)">
                        <img src="@/assets/images/user/talk/SigninLogo.png" alt="">
                        <span>签到</span>
                    </div>
                    <!-- 判断是否可以签到 -->
                    <div class="signBtnb" v-if="item.state == 3&&(item.mark_end.substring(0,10) + '23:59:59') <newDate" @click="$toast({message:'已过期'})">
                        <img src="@/assets/images/user/talk/lgob.png" alt="">
                        <span>签到</span>
                    </div>
                    <!-- 体验成功的体验反馈 -->
                    <div class="signBtnc" v-if="item.state == 4&& item.feed_id == 0" @click="feedBack(item.id)">
                        <span class="overtime">体验反馈</span>
                    </div>
                    <!-- <div class="signBtn" v-if="item.state == 8 " @click="overTimeClick(item.id)"> -->
                    <!-- 判断是否已超时并且没有填写过超时原因 -->
                    <div class="signBtn" v-if="item.state == 8 && item.mark_out == null" @click="overTimeClick(item.id)">
                        <span class="overtime">超时原因</span>
                    </div>
                    <!-- 分享 -->
                    <!-- item.sub[item.sub.length - 1].mark_start -->
                    <div class="share" v-if="item.state <= 3 && newDate <= item.sub[item.sub.length - 1].mark_end.substring(0,10) + '23:59:59'" @click="shareFriend(item.sub)">
                        <img src="@/assets/images/user/talk/share.png" alt="">
                    </div>
                    <div class="record-title flc">
                        <div class="record-title-name">{{ item.uname }}</div>
                        <div class="record-title-status">
                            <span v-if="item.state == 0">待预约</span>
                            <span v-else-if="item.state == 1">已预约</span>
                            <span v-else-if="item.state == 2">已邀请</span>
                            <span v-else-if="item.state == 3">已回执</span>
                            <span v-else-if="item.state == 4">已体验</span>
                            <span v-else-if="item.state == 8">已超时</span>
                            <span v-else-if="item.state == 9">已取消</span>
                        </div>
                    </div>
                    <div class="record-home">{{ item.address }}</div>
                    <div class="record-info">体验地点：{{ item.experience_address }}</div>
                    <div class="record-info">
                        <span class="record-time">预约时间：</span>
                        <span class="record-infos">
                            <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}</span>
                        </span>
                    </div>
                    <!-- <div class="record-info">预约时间：{{ item.mark_date.split('-').join('.') }} {{ item.mark_start.substring(11,16)}}~{{item.mark_end.substring(11,16)}}</div> -->
                    <div class="record-info">
                        <div class="remark-title">备注：</div>
                        <div class="remark-info">
                            <span class="remark-info-item">
                                {{remarks(item.sub)}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>

        <!-- 海报分享(已藏在背景下面) -->
        <!-- <van-popup class="poster-pop" style="z-index:-1 !important;" v-model="posterShow" @close="popupClose">
            <div class="poster-pop-wrap">
                <div class="container" ref="invitationImgRef">
                    <div class="title">
                        敬请扫码
                    </div>
                    <div class="qrcode" id="qrcode" ref="qrcodeBox"></div>
                    <div class="userinfo">
                        <div class="user-name-title">邀约人:</div>
                        <div class="user-name">{{ReportUserInfoData.sign_name}}</div>
                        <div>联系方式:</div>
                        <div>{{ReportUserInfoData.sign_phone}}</div>
                    </div>
                </div>
                <div class="pop-btn-wrap">
                    <div class="pop-btn" @click="posterShow = false">取消</div>
                    <div class="pop-btn" @click="htmlToImage">保存</div>
                </div>
            </div>
        </van-popup> -->
       
        <van-popup class="poster-pop" v-model="posterShow2" @close='closePopup'>
            <div class="poster-pop-wrap">
                <div class="container">
                    <img :src="photo_url" class="poster" alt="">
                    <img class="logo" src="@/assets/images/user/talk/logo.png" alt="">
                    <img class="right" src="@/assets/images/user/talk/right.png" alt="">
                    <img class="left" src="@/assets/images/user/talk/left.png" alt="">
                    <div class="center">
                        <div class="title">
                            AI-LiNK体验邀请函
                        </div>
                        <div class="content">
                            <p>尊敬的    <span>{{ReportUserInfoData.uname}}</span>       先生/女士</p>
                            <!-- <p>尊敬的    <span></span>       先生/女士</p> -->
                            <p>您好！</p>
                            <p>特邀您前往A.O.史密斯AI-LiNK城市体验中心，对AI-LiNK冷暖风水专业集成系统的设计、施工及使用效果进行体验，期待您的光临！</p>
                        </div>
                        <div class="accept">
                            <img class="acceptimg" src="@/assets/images/user/talk/accept.png" alt="">
                        </div>
                    </div>
                    <div class="address">
                        <div class="addr">
                            <p><span class="address-title">体验地址</span><span class="address-name">{{ReportUserInfoData.experience_name}}</span></p> 
                            <p class="address-addr">详细地址：{{ReportUserInfoData.experience_address}}</p>
                            <!-- <p><span class="address-title">体验地址</span><span class="address-name"></span></p> -->
                            <!-- <p class="address-addr">详细地址：</p> -->
                        </div>
                        <div class="navigation">
                            <img src="@/assets/images/user/talk/navigation.png" alt="">
                        </div>
                    </div>
                    <div class="time">
                        <div>体验时间</div>
                        <div>{{ReportUserInfoData.mark_start}}</div>
                    </div>
                    <div class="userinfo">
                        <span class="user-name-title">邀约人:</span>
                        <span class="user-name">{{ReportUserInfoData.sign_name}}</span>
                        <span>联系方式:</span>
                        <span>{{ReportUserInfoData.sign_phone}}</span>
                    </div>
                    <div class="bottom">
                        <div class="xieyi">
                            <span class="checkbox"><span class="check"></span></span>
                            <span>A.O.史密斯用户隐私授权条款</span>
                        </div>
                    </div>
                </div>
                <div class="pop-btn-wrap2">
                    <div class="item2">
                        <div class="pop-btn" >长按保存海报</div>
                        <img :src="photo_url" alt="">
                    </div>
                </div>
            </div>
        </van-popup>

        <!-- 填写超时原因 -->
        <van-popup class="date-pop" v-model="overtime">
            <div class="pop-wrap cancelPopups">
                <div class="pop-title">
                    请填写超时原因
                </div>
                <div class="texttare-class">
                    <textarea v-model="overtimeInfo" placeholder="请输入超时原因："  class="text-style" name="" id="" cols="30" rows="8"></textarea>
                </div>
                <div class="pop-btn-wrap">
                    <div class="pop-btn" @click="overtime = false">取消</div>
                    <div class="pop-btn" @click="confirm">提交</div>
                </div>
            </div>
        </van-popup>
        <share :bShowNrom.sync="data.bShowNrom" :confit="data.confit"></share>
    </div>
</template>

<script>
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'
import share from "@/page/proposal/scheme/components/share/index"; //分享
import html2canvas from 'html2canvas'
import detail from "@/js/detail.js";
import QRCode from 'qrcodejs2'
let OSS = require("ali-oss");
let progressTime = null;
    export default {
        name: "myappoint",
        components:{
            share
        },
        data() {
            return {
                posterShow2:false,//控制信息海报
                photo_url:'',//海报图片地址
                loading:false,//控制触底刷新
                finished:false,//控制是否还有数据
                overtime:false,//控制超时原因弹窗
                posterShow:false,//控制海报开关
                searchText:'',
                id:'',//存储的report_id
                data:{},//存储企业微信转发需要的数据
                qrcode:'',//二维码的内容
                overtimeInfo:'',//超时原因
                options:{
                    page:0,limit:10
                },
            }
        },
        mounted() {
        },
        created () {
            // $init(() => {
                fetchVerifyAuthForB (() => {
                    Promise.all([
                        this.$store.dispatch({type:'userTalkAppoint/getReportListData',...this.options}),
                        this.$store.dispatch({type:'userTalkAppoint/getCustomerData',page:0,limit:40})
                    ]).then ( () => {
                        this.createPreview()
                    })
                })
            // })
        },
        watch : {
            searchText :{
                handler (newText,oldText) {
                    if (newText == '') {
                        this.$store.dispatch({type:'userTalkAppoint/getReportListData',page:0,limit:40}).then ( () => {
                            this.finished = false
                        })
                    }
                }
            }
        },
        beforeRouteEnter (to,from,next) {
            next((vm) => {
                // 如果用户是直接进入的我的预约，那么要让父路由选中也是我的预约，，但是默认它是选中体验预约，所以需要添加一个路由守卫
                vm.$emit('myappoint')
            })
        },
        methods: {
            // 体验反馈触发的函数
            feedBack (id) {
                this.$router.push(`/hvac/talk/feedback?id=${id}`)
            },
            closePopup () {
                console.log('清楚二维码');
                this.$refs.qrcodeBox.innerHTML = ''
            },
            loadOver () {
                this.loading = true
                this.options.page = this.options.page + 1
                console.log(this.options,'options');
                let length = this.ReportListData.length
                this.$store.dispatch({type:'userTalkAppoint/getReportListDatas',...this.options,search:this.searchText}).then( () => {
                    console.log('添加成功');
                    this.loading = false
                    if (length == this.ReportListData.length) {
                        this.finished = true
                    } 
                })
            },
            // 点击超时原因触发的函数
            overTimeClick (id) {
                this.id = id
                this.overtime = true
            },
            // 每个预约记录的备注
            remarks (list) {
                let remarks = []
                if (list.length == 0 ) {
                    return []
                }
                // 备注数组去重，同时不显示 备注为空
                list.forEach( (item,index) => {
                    if ( item.mark != '' ) {
                        const i = list.findIndex( item2 => item2.mark == item.mark )
                        if ( i == index) {
                            remarks.unshift(item.mark)
                        }
                    }
                })
                return remarks.join(' /')
            },
            // 确定提交超时原因
            confirm () {
                this.$store.dispatch({type:'userTalkAppoint/SendreportoutInfo',report_id:this.id,mark_out:this.overtimeInfo}).then (() => {
                    this.overtime = false
                    this.$toast({message:'填写成功'})
                    this.$store.commit({type: 'userTalkAppoint/addOverTimeInfo', id:this.id,mark_out:this.overtimeInfo});
                })
            },
            // base64 转 Blod
            base64ToLife(dataurl, filename) {
                return new Promise((resolve, reject) => {
                    const arr = dataurl.split(",");
                    const mime = arr[0].match(/:(.*?);/)[1];
                    const bstr = atob(arr[1]);
                    let n = bstr.length;
                    const u8arr = new Uint8Array(n);
                    while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                    }
                    let blod = new Blob([u8arr], { type: mime });
                    // blod.lastModifiedDate = new Date();
                    // blod.name = filename;
                    resolve(blod);
                });
            },
            //生成长图
            htmlToImage() {
                // console.log('父')
                let that = this;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                let sHeight = 604;
                let sWidth = 312;
                let scale = 2;
                this.$store.commit("loadSwitch", true);
                html2canvas(that.$refs.invitationImgRef, {
                    useCORS: true,
                    // backgroundColor:null,
                    // height: sHeight,
                    // width: sWidth,
                    dpi: 72,
                    // scale: scale,
                })
                    .then((canvas) => {
                        let sUrl = canvas.toDataURL("image/png");
                        this.getOssSts(sUrl);
                        this.$store.commit("loadSwitch", false);
                        // console.log(sUrl,'surl');
                        console.log('成功');
                    })
                    .catch((fail) => {
                        console.log('失败');
                        this.$store.commit("loadSwitch", false);
                        console.log(fail);
                    });
                console.log("长图", sHeight, sWidth);
            },
            // 生成二维码
            crateQrcode () {
                console.log(window.location.href.split('/hvac/talk/appoint')[0] + '/user/invitation/invitation' + '?report_id=' + this.id,'网址');
                var qrcode = new QRCode(this.$refs.qrcodeBox, {  
                    text: window.location.href.split('/hvac/talk/myappoint')[0] + '/user/invitation/invitation' + '?report_id=' + this.id,
                    // text: 'https://www.baidu.com/',
                    width: 90,  
                    height: 90,  
                    colorDark: '#000000',  
                    colorLight: '#ffffff',  
                    correctLevel: QRCode.CorrectLevel.L
                });
                // console.log(this.qrcode)
            },
            getShareImg(id) {
                let that = this;
                that.$store.commit("loadSwitch", true);
                detail.getShareImg({ nId: id }).then((res) => {
                    let img = new Image();
                    let image_url = res.result.image_url;
                    // img.onload = () => {
                    //     that.objImg = image_url;
                    //     this.$toast({
                    //         message:'您可长按保存图片'
                    //     })
                    // };
                    // img.src = image_url;
                    this.photo_url = image_url
                    console.log(this.photo_url,'url');
                    //  console.log("图片路径", res.result.image_url);
                });
            },
            async savePoster(sFileName) {
                let oData = {
                    image_url: sFileName,
                };
                let oSavePoster = await detail.getPoster(oData);
                let nPosterId = oSavePoster.result;
                //  console.log(nPosterId);
                // debugger
                // this.nRate = 100;
                clearInterval(progressTime);
                setTimeout(() => {
                    //  console.log(nPosterId);
                    // wx.miniProgram.redirectTo({
                    //     url: `/pages/case/poster/index?nId=${nPosterId}`
                    // });
                    // this.$router.push({ path: `/antshare/index?nId=${nPosterId}` });
                    this.getShareImg(nPosterId)
                    this.$store.commit("loadSwitch", false);
                }, 1000);
            },
            // 上传图片到oss
            async ossUploadImg(oOss, oFile) {
                let client = new OSS({
                    region: oOss.sts.region,
                    bucket: oOss.sts.bucket,
                    accessKeyId: oOss.sts.access_key_id,
                    accessKeySecret: oOss.sts.access_key_secret,
                    endpoint: oOss.sts.endpoint_internal,
                    stsToken: oOss.sts.security_token,
                    //cname: true,
                    // timeout:30,
                    secure: true,
                });
                try {
                    //  console.log(oOss.object_name, oFile);
                    client
                    .multipartUpload(oOss.object_name, oFile)
                    .then((res) => {
                        //  console.log(res);
                        let sFileName = res.name;
                        this.savePoster(oOss.filename); //保存海报
                    })
                    .catch((err) => {
                        //  console.log("错误信息", err);
                    });
                } catch (e) {
                    //  console.log(e);
                }
            },
            // 获取oss配置
            async getOssSts(sUrl) {
                let oOssData = await detail.getOsssts({
                    ext: "png",
                });
                let oOss = oOssData.result;
                //  console.log("加密数据", oOssData);
                let sKey = `tbzIwry9lT0qU81m${oOss.timestamp}`;
                // let oOssDecrypt = this.decrypt(sKey, oOss.body);
                // console.log('需要上传的图片',sUrl)
                let oFile = await this.base64ToLife(sUrl, oOss.key);
                this.ossUploadImg(oOss, oFile);
            },
            // 点击分享
            shareFriend (list) {
                this.posterShow = true
                this.posterShow2 = true
                function compare (property) {
                    return function (a,b) {
                        let value1 =  a[property];
                        let value2 =  b[property];
                        if (value1.substring(11,13) == value2.substring(11,13)) {
                            return value1.substring(14,16) - value2.substring(14,16)
                        } else {
                            return value1.substring(11,13) - value2.substring(11,13);
                        }
                    }
                }
                let arr = list.sort(compare('mark_start'))
                this.id = arr[0].id;
                console.log(arr[0]);
                this.$store.dispatch({type: 'userTalkAppoint/SendReportShare',report_id: this.id});
                this.$store.dispatch({type: 'userTalkAppoint/getReportInfoData',report_id:this.id}).then(() => {
                    this.$nextTick(() => {
                        this.crateQrcode()
                        this.$nextTick(() => {
                            this.htmlToImage()
                        })
                    })
                })

            },
            // 点击签到触发的函数
            signClick (list) {
                function compare (property) {
                    return function (a,b) {
                        let value1 =  a[property];
                        let value2 =  b[property];
                        if (value1.substring(11,13) == value2.substring(11,13)) {
                            return value1.substring(14,16) - value2.substring(14,16)
                        } else {
                            return value1.substring(11,13) - value2.substring(11,13);
                        }
                    }
                }
                let arr = list.sort(compare('mark_start'))
                this.id = arr[0].id;
                window.location.href = window.location.origin + '/hvac/talk/signIn?id=' +this.id
                // this.$router.push('/hvac/talk/signIn?id=' + this.id)
                this.$store.commit("loadSwitch", true);
            },
            // 点击问号搜索
            search () {
                if (!this.searchText.trim()) {
                    return
                } else {
                    this.$store.dispatch({type:'userTalkAppoint/getReportListData',page:0,limit:10,search:this.searchText}).then(() => {
                        this.finished = false
                    })
                }
            },
            createPreview() {
                const CHARTS = this.$echarts.init(
                    document.getElementById("chart-bar")
                );
                const option = {
                    color: ['#318544', '#bfbfbf'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            // Use axis to trigger tooltip
                            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                        },
                        formatter: function (params) {
                            var res = "<div style='margin-bottom:5px;padding:0 12px;width:100%;height:24px;line-height:24px;border-radius:50%;'><p>" +
                            params[0].name + " </p></div>";
                            for (var i = 0; i < params.length; i++) {
                                let data = 0
                                if (params[i].data) {
                                    data = params[i].data
                                }
                                //因为是个数组，所以要遍历拿到里面的数据，并加入到tooltip的数据内容部分里面去
                                res += `<div style="color: #fff;font-size: 14px; padding:0 12px;line-height: 24px">
                                    <span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${[
                                        params[i].color, // 默认是小圆点，我们将其修改成有圆角的正方形，这里用的是模板字符串。并拿到对应颜色、名字、数据
                                    ]};"></span>
                                    ${params[i].seriesName}
                                    ${data}%
                                    </div>`;
                            }
                            return res; // 经过这么一加工，最终返回出去并渲染，最终就出现了我们所看的效果
                        },
                    },
                    legend: {
                        textStyle: {
                            color: 'auto',
                            fontSize: 12
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '6%',
                        bottom: '3%',
                        top: '30%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        data: [0, 20, 40, 60, 80, 100],
                        axisLabel: {
                            formatter: function (res) {
                                return res + '%'
                            },
                            textStyle: {
                                color: '#939393',
                                fontSize: 12
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(57, 158, 104, 0.2)'
                            }
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: ['体验达成','用户邀约'],
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#399E68'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#444444',
                                fontSize: 12
                            }
                        },
                    },
                    series: [
                        {
                            name: '完成',
                            type: 'bar',
                            stack: 'total',
                            barWidth: 16,
                            label: {
                                show: true,
                                formatter: function (res) {
                                    return res.data + '%'
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: this.failDataList
                        },{
                            name: '未完成',
                            type: 'bar',
                            stack: 'total',
                            barWidth: 16,
                            label: {
                                show: true,
                                formatter: function (res) {
                                    return res.data + '%'
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: this.successDataList
                        }
                    ]
                };
                CHARTS.setOption(option);
            },
        },
        computed: {
            ReportUserInfoData() {
                return this.$store.state.userTalkAppoint.ReportUserInfoData
            },
            // 获取当前时间
            newDate () {
                let newDate = new Date();
                const year = newDate.getFullYear();
                let month = newDate.getMonth() + 1;
                let date = newDate.getDate();
                let minute = newDate.getMinutes();
                let second = newDate.getSeconds()
                let hour = newDate.getHours();
                month = (month < 10) ? '0' + month : month
                date = (date < 10) ? '0' + date : date
                hour = (hour < 10) ? '0' + hour : hour
                minute = (minute < 10) ? '0' + minute : minute
                second = (second < 10) ? '0' + second : second
                return   year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
            },
            failDataList () {
                let list = []
                // 判断数据中是否带有0，如果有就使用空替代，不显示0
                if (this.ReportCount.Experience != 0) {
                    list[0] = this.ReportCount.Experience
                } else {
                    list[0] = ''
                }
                if (this.ReportCount.Invite != 0 ) {
                    list[1] = this.ReportCount.Invite
                } else {
                    list[1] = ''
                }
                if (this.ReportCount.zero) {
                    return ['','']
                } else{
                    return list
                }
            },
            successDataList () {
                let list = []
                // 判断数据中是否带有0，如果有就使用空替代，不显示0
                if ((100 - this.ReportCount.Experience) != 0) {
                    list[0] = (100 - this.ReportCount.Experience)
                } else {
                    list[0] = ''
                }
                if ((100 - this.ReportCount.Invite) != 0 ) {
                    list[1] = (100 - this.ReportCount.Invite)
                } else {
                    list[1] = ''
                }
                if (this.ReportCount.zero) {
                    return ['','']
                } else{
                    return list
                }
            },
            // 这个用户id就是当前签单手id、
   
            ReportListData () {
                const userid = this.$store.state.userTalkAppoint.CustomerData[0]?.new_salesperson_id
                const list = this.$store.state.userTalkAppoint.ReportListData.filter( item => {
                    return item.user_id_sign == userid
                })
                console.log(list.length,'list');
                return list
            },
            ReportCount () {
                return this.$store.state.userTalkAppoint.ReportCount
            }
        }
    }
</script>

<style lang="scss" scoped>
    .date-pop {
        width: 76%;
        top: 40.5%;
        border-radius: 16px;
    }
/*海报弹窗*/
    .poster-pop-wrap {
        // .poster  {
        //     width: 624px;
        //     height: 1208px;
        //     // background-color: red;
        //     box-sizing: border-box;
        //     background-image: url('~@/assets/images/user/talk/poster-bg.png');
        //     background-size: cover;
        //     .logo {

        //     }
        // }
         .container{
            border-radius: 10px;
            width: 624px;
            height: 1208px;
            background-image: url('~@/assets/images/user/talk/invitationbg.png');
            background-size: cover;
            position: relative;
            padding-top:167px ;
            z-index:10;
            .poster {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height:1208px;
                opacity: 0;
                z-index: 13;
            }
            .logo{
                width: 236px;
                height: 28px;
                position: absolute;
                left: 62px;
                top: 86px;
            }
            .left {
                z-index: 999;
                width: 122px;
                height: 173px;
                position: absolute;
                top: 480px;
                left: 1px;
            }
            .center {
                width: 512px;
                height: 512px;
                margin: 0 auto ;
                background-image: url('~@/assets/images/user/talk/center.png');
                background-size: cover;
                position: relative;
                .title{
                    font-size: 38px;
                    font-weight: 500;
                    color: #986F34;
                    padding-top: 64px;
                    text-align: center;
                }
                .content {
                    padding: 21px 54px 0 92px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 35px;
                    p {
                        margin-bottom: 5px;
                        &:last-of-type {
                            margin-bottom: 0;
                        }
                        span {
                            white-space: nowrap;
                            text-align: center;
                            display: inline-block;
                            min-width: 107px;
                            border-bottom: solid 1px #000000;
                        }
                    }
                }
                .accept {
                    width: 295px;
                    height: 76px;
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%);
                    bottom: 51px;
                    .acceptimg{
                        width: 295px;
                        height: 74px;
                    }
                }
            }
            .address {
                display: flex;
                padding: 43px 61px 0 71px;
                .addr {
                    flex: 1;
                    p{
                        margin-bottom: 10px;
                    }
                    .address-title {
                        display: inline-block;
                        text-align: center;
                        border-left: #E5CEA4 1px solid ;
                        padding-left: 8px;
                        font-size: 24px;
                        font-family: SourceHanSansCN;
                        font-weight: 400;
                        color: #E5CEA4;
                    }
                    .address-name {
                        font-size: 24px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 20px;
                    }
                    .address-addr {
                        font-size: 20px;
                        font-weight: 300;
                        color: #FFFFFF;
                        line-height: 28px;
                    }
                }
                .navigation {
                    width: 71px;
                    height: 62px;
                    img {
                        width: 71px;
                        height: 62px;
                    }
                }
            }
            .time {
                margin-top: 31px;
                text-align: center;
                div{
                    display: inline-block;
                }
                div:first-child {
                    width: 119px;
                    font-size: 24px;
                    font-family: SourceHanSansCN;
                    font-weight: 400;
                    color: #E5CEA4;
                    border-left: solid 1px #E5CEA4;
                    border-right: solid 1px #E5CEA4;
                }
                div:last-child{
                    font-size: 24px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 18px;
                    margin-left: 13px;
                }
            }
            .userinfo {
                margin: 54px 95px 0 95px;
                border-top:#FFFFFF 1px solid ;
                border-bottom:#FFFFFF 1px solid ;
                padding: 12px 0;
                text-align: center;
                span:nth-child(1) {
                    font-size: 21px;
                    font-weight: 400;
                    color: #EBDBB6;
                }
                span:nth-child(2) {
                    margin-left: 15px;
                    font-size: 21px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                span:nth-child(3) {
                    margin-left: 20px;
                    font-size: 21px;
                    font-weight: 400;
                    color: #EBDBB6;
                }
                span:nth-child(4) {
                    font-size: 21px;
                    margin-left: 15px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
            .bottom{
                margin-top: 53px;
                text-align: center;
                line-height: 50px;
                
                .xieyi {
                    font-size: 18px;
                    font-family: SourceHanSansCN;
                    font-weight: 300;
                    color: #FFFFFF;
                    line-height: 50px;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                    .checkbox {
                        width: 17px;
                        height: 17px;
                        border-radius: 50%;
                        border: solid #FFFFFF 1px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                        .check {
                            width: 10px;
                            border-radius: 50%;
                            height: 10px;
                            background-color: #FFFFFF;
                        }
                    }
                }
            }
            .right{
                width: 138px;
                height: 159px;
                position:absolute;
                top: 110px;
                z-index: 999;
                right: 1px;
            }
        }
       
        .pop-btn-wrap {
            .pop-btn {
                width: 296px;
                background: linear-gradient(136deg, #4EA062 0%, #338444 100%) !important;
                border: none;
                color: #fff!important;
            }
        }
        .pop-btn-wrap {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin-top: 24px;
            .pop-btn {
                width: 208px;
                height: 80px;
                font-size: 28px;
                font-weight: 400;
                line-height: 80px;
                text-align: center;
                border-radius: 12px;

                &:first-child {
                    border: 2px solid #318544;
                    color: #318544;
                }
                &:last-child {
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    color: #fff;
                }
            }
        }
        .pop-btn-wrap2 {
            margin-top: 24px;
            .item1{
                display: flex;
                justify-content: space-between;
                width: 100%;
                .pop-btn {
                    width: 278px;
                    height: 80px;
                    font-size: 28px;
                    font-weight: 400;
                    line-height: 80px;
                    text-align: center;
                    border-radius: 12px;
    
                    // &:first-child {
                        border: 2px solid #318544;
                        // color: #318544;
                    // }
                    // &:last-child {
                        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                        color: #fff;
                    // }
                }
            }
            .item2 {
                margin-top: 10px;
                position: relative;
                overflow: hidden;
                .pop-btn {
                    z-index:10;
                    width: 100%;
                    height: 80px;
                    font-size: 28px;
                    font-weight: 400;
                    line-height: 80px;
                    text-align: center;
                    border-radius: 12px;
    
                    // &:first-child {
                        border: 2px solid #318544;
                        // color: #318544;
                    // }
                    // &:last-child {
                        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                        color: #fff;
                    // }
                }
                img {
                    z-index: 13;
                    opacity: 0;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom:0;
                }
            }
        }
    }
/*预约弹窗样式*/
    .pop-wrap {
        height: 460px;
        background: #FFFFFF;
        border-radius: 16px;
        overflow: hidden;

        .pop-title {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #444444;
            line-height: 44px;
            text-align: center;
            margin-top: 40px;
        }

        .texttare-class {
            margin-top: 20px;
            padding: 0 40px;
            .text-style {
                padding: 20px;
                box-sizing: border-box;
                height: 220px;
                width: 100%;
                border-radius: 16px;
                background: #f7f7f7;

            }
        }

        .pop-content {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #318544;
            line-height: 40px;
            text-align: center;
            margin-top: 60px;
        }


          .pop-btn-wrap {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin-top: 24px;

            .pop-btn {
                width: 208px;
                height: 80px;
                font-size: 28px;
                font-weight: 400;
                line-height: 80px;
                text-align: center;
                border-radius: 12px;

                &:first-child {
                    border: 2px solid #318544;
                    color: #318544;
                }
                &:last-child {
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    color: #fff;
                }
            }
        }
    }
    .card-wrap {
        z-index: 10;
        width: 91.2%;
        margin: 0 auto 30px;
        background: #FFFFFF;
        border-radius: 12px;
        padding: 28px 24px 30px;
            .container2{
                position: absolute;
                z-index: -1;
                top: -107vh;
                border-radius: 10px;
                width: 624px;
                height: 1021px;
                // background-image: url('~@/assets/images/user/talk/background.png');
                // background-size: 100% 100%;
                padding-top:167px ;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;top: 0;
                    bottom: 0;
                    z-index: 9;
                }
                .title {
                    text-align: center;
                    margin-top: 376px;
                    margin-bottom: 20px;
                    color: #fff;
                    font-size: 30px;
                }
                .qrcode {
                    width: 200px;
                    margin:0 auto 0;
                    height: 200px;
                    background-color: #fff;
                    padding: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .userinfo {
                    width: 100%;
                    position: absolute;
                    bottom:-60px;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    div:nth-child(1) {
                        font-size: 21px;
                        font-weight: 400;
                        color: #EBDBB6;
                    }
                    div:nth-child(2) {
                        margin-left: 15px;
                        font-size: 21px;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                    div:nth-child(3) {
                        margin-left: 20px;
                        font-size: 21px;
                        font-weight: 400;
                        color: #EBDBB6;
                    }
                    div:nth-child(4) {
                        font-size: 21px;
                        margin-left: 15px;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
            }
        /*卡片标题*/
        .card-title {
            .color-block {
                width: 6px;
                height: 32px;
                background: #318544;
                margin-right: 12px;
            }
            .card-title-text {
                font-size: 32px;
                font-weight: 600;
                color: #318544;
                line-height: 44px;
            }
        }

        /*预约回顾echarts*/
        #chart-bar {
            width: 100%;
            height: 234px;
        }
        ::v-deep .van-overlay {
            z-index: 9!important;
        }
        ::v-deep .poster-pop {
            z-index: 10!important;
        }
        /*分享下弹窗*/
        .share-pop-wrap {
            height: 100%;
            background: #fff;
            border-radius: 24px 24px 0px 0px;
            padding: 38px 32px 80px 36px;

            .share-pop-title {
                display: flex;
                align-items: center;
                justify-content: space-between;

                div {
                    font-size: 32px;
                    font-weight: 400;
                    color: #222222;
                    line-height: 44px;
                }
                img {
                    width: 32px;
                    height: 32px;
                }
            }

            .share-list {
                margin-top: 46px;

                .share-item {
                    width: 100%;
                    background: #F6F9F6;
                    border-radius: 12px;
                    padding: 40px 30px 40px 32px;
                    justify-content: space-between;
                    margin-bottom: 24px;
                    &:last-child {
                        margin: 0;
                    }

                    .share-item-left {
                        img {
                            width: 72px;
                            height: 72px;
                            margin-right: 24px;
                        }
                        div {
                            font-size: 28px;
                            font-weight: 400;
                            color: #222222;
                            line-height: 40px;
                        }
                    }

                    .share-item-right {
                        background: #318544;
                        border-radius: 30px;
                        padding: 14px 24px;

                        font-size: 24px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 32px;
                    }
                }
            }
        }
        /*预约记录搜索框*/
        .record-input {
            width: 100%;
            padding: 20px 24px;
            background: #F7F7F7;
            border-radius: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 26px 0 4px;

            input {
                width: 80%;
                font-size: 28px;
                font-weight: 400;
                color: #A2A2A2;
                line-height: 40px;
                background: #F7F7F7;
            }
            img {
                width: 40px;
                height: 40px;
            }
        }

        /*预约记录列表*/
        .record-list {
            // overflow: hidden;
            .record-item {
                margin-top: 28px;
                padding-bottom: 20px;
                border-bottom: 2px dashed #F1F1F1;
                position: relative;
                .signBtn{
                    background: linear-gradient(90deg, #46B46B 0%, #318544 100%);
                    box-shadow: 0px 8px 24px 0px rgba(49,133,68,0.2);
                    border-radius: 70px 0px 0px 70px;
                    position: absolute;
                    height:70px;
                    right: -24px;
                    bottom: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 4px 24px 6px 16px;
                    .overtime {
                        margin-left: 10px;
                    }
                    img {
                        width: 58px;
                        height: 60px;
                    }
                    span {
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 34px;
                    }
                }
                .share {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    bottom: 50%;
                    right: 0;
                    img {
                        width: 60px;
                        height: 60px;
                    }
                }
                .signBtnb{
                    position: absolute;
                    right: -24px;
                    bottom: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: linear-gradient(90deg, #bfbfbf 0%, #f7f7f7 100%);
                    padding: 4px 24px 6px 16px;
                    box-shadow: 0px 4px 12px 0px rgba(18, 21, 19, 0.2);
                    border-radius: 70px 0px 0px 70px;
                    img {
                        width: 58px;
                        height: 60px;
                    }
                    span {
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 34px;
                    }
                }
                
                .signBtnc {
                    position: absolute;
                    right: 0;
                    bottom: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #318544;
                    padding: 12px 28px;
                    border-radius: 4px;
                    border: 2px solid #318544;
                }
                .record-title {
                    // justify-content: space-between;
                    .record-title-name {
                        font-size: 28px;
                        font-weight: 600;
                        color: #318544;
                        line-height: 40px;
                    }
                    .record-title-status {
                        margin-left: 24px;
                        font-size: 24px;
                        font-weight: 400;
                        color: #A2A2A2;
                        line-height: 32px;
                    }
                }

                .record-home {
                    font-size: 24px;
                    font-weight: 400;
                    color: #444444;
                    line-height: 34px;
                    margin-top: 6px;
                }
                .record-info {
                    font-size: 24px;
                    font-weight: 400;
                    color: #858585;
                    line-height: 32px;
                    margin-top: 12px;
                    display: flex;
                    .record-time {
                        width: 130px;
                    }
                    .record-infos{
                        text-align: left;
                        display: flex;
                        flex-direction: column;
                        span{
                            height: 32px;
                        }
                    }
                    .remark-title {
                        width: 130px;
                    }
                    .remark-info {
                        flex: 1;
                    }
                }
            }
        }
    }
    .share-pop {
        border-radius: 24px 24px 0px 0px;
    }
    .poster-pop {
        user-select: none;
        width: 83.2%;
        top: 50%;
        background: transparent !important;
    }
    /*通用样式*/
    .flc {
        display: flex;
        align-items: center;
    }
</style>